import { useCallback, useRef } from "react";

/**
 * Faz o brilho radial (--mx/--my) seguir o cursor dentro do elemento.
 * Usar junto das classes `.spotlight` e/ou `.border-glow`.
 */
export default function useSpotlight() {
  const ref = useRef(null);

  const onMouseMove = useCallback((event) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${event.clientX - rect.left}px`);
    el.style.setProperty("--my", `${event.clientY - rect.top}px`);
  }, []);

  return { ref, onMouseMove };
}
